<template>
  <div class="product-package-container" :class="colorClass">
    <section>
      <slot :name="'content'"></slot>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'ProductPackage',
    props: {
      product: {
        required: true,
        type: String,
      },
    },
    computed: {
      colorClass() {
        switch (this.product) {
          case 'Estate':
            return 'estate-assist-color';
          case 'Edu':
            return 'education-assist-color';
          case 'Debt':
            return 'debt-assist-color';
          case 'Cash':
            return 'cash-assist-color';
          case 'Cost':
            return 'cost-assist-color';
          case 'Tax':
            return 'tax-assist-color';
          default:
            return '';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .product-package-container {
    display: flex;
    width: 100%;
    background-color: #f2f2f2;
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: 24px;
    padding-right: 24px;
    min-height: 188px;
    height: 100%;

    section {
      width: 100%;
    }
  }

  .product-package-container.estate-assist-color {
    border-left: 3px solid #ed0080;
  }

  .product-package-container.education-assist-color {
    border-left: 3px solid #7395ef;
  }

  .product-package-container.debt-assist-color {
    border-left: 3px solid #d65e23;
  }

  .product-package-container.cash-assist-color {
    border-left: 3px solid #8aba3e;
  }

  .product-package-container.cost-assist-color {
    border-left: 3px solid #e9ab21;
  }

  .product-package-container.tax-assist-color {
    border-left: 3px solid #e9ab21;
  }
</style>
